const PRIORITY_OPTIONS = [
  { value: 4, label: "None", color: "border-l-warm-border" },
  { value: 3, label: "Low", color: "border-l-yellow-400" },
  { value: 2, label: "Med", color: "border-l-orange-500" },
  { value: 1, label: "High", color: "border-l-red-700" },
] as const;

export default function TaskPriorityButtons({
  priority,
  onChange,
}: {
  priority: number;
  onChange: (priority: number) => void;
}) {
  return (
    <div>
      <label className="block text-xs font-medium text-warm-text-tertiary mb-2 uppercase tracking-wider">
        Priority
      </label>
      <div className="flex gap-2">
        {PRIORITY_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            aria-pressed={priority === option.value}
            onClick={() => onChange(option.value)}
            className={`flex-1 px-2 py-2 rounded-card border-l-4 text-sm transition-all duration-150 ease-in-out text-left ${
              priority === option.value
                ? `${option.color} bg-warm-bg-card border border-warm-border shadow-soft-md text-warm-text-primary font-medium`
                : `${option.color} bg-warm-bg-elevated border border-warm-border text-warm-text-secondary opacity-60 hover:opacity-90 hover:shadow-soft-sm`
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
